import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import BasicButton from "@components/core/buttons/BasicButton";
import { ROUTES } from "@routes/Routes";
import { useNavigate } from "react-router-dom";

interface TransactionBackButtonProps {
  link: boolean;
  className?: string;
}

const TransactionBackButton: FunctionComponent<TransactionBackButtonProps> = ({
  link,
  className = "",
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <BasicButton
      variant={link ? "transparent-tertiary" : "tertiary"}
      text={
        link
          ? t("transaction.detail.back")
          : t("transaction.detail.backToDashboard")
      }
      onClick={() => navigate(ROUTES.extranet.home.generate())}
      className={`py-11 px-30 font-extra-small ${className}`}
    />
  );
};

export default TransactionBackButton;
